import React from 'react';
import { RubigramStore } from '../RubigramStore';
import Instructions from './Instructions';
import { PuzzleNames } from '../../../../utils/types';
import { onReveal, saveRubigram } from '../rubigramUtils';
import PuzzleTopBar from '../../shared/PuzzleTopBar';
import { isMobile } from 'react-device-detect';
import { useIsMobileDimensions } from '../../shared/utils';
import MobileRubigramInstructions from './MobileInstructions';

const RubigramTopBar = () => {
  const useMobileStyles = isMobile || useIsMobileDimensions();

  return (
    <PuzzleTopBar
      puzzleName={PuzzleNames.Rubigram}
      store={RubigramStore as any}
      onReveal={onReveal}
      onSave={saveRubigram}
      InstructionsComponent={useMobileStyles ? MobileRubigramInstructions : Instructions}
    />
  );
};

export default RubigramTopBar;